import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
}

const SectionHeading = ({ 
  title, 
  subtitle, 
  description, 
  align = "center",
  className 
}: SectionHeadingProps) => {
  return (
    <div className={cn(
      "mb-12",
      align === "center" && "text-center",
      className
    )}>
      {subtitle && (
        <span className="text-primary font-semibold text-sm uppercase tracking-wider mb-2 block">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 relative inline-block">
        {title}
        <span className="absolute -bottom-2 left-0 w-16 h-1 bg-primary rounded-full" />
      </h2>
      {description && (
        <p className="text-muted-foreground max-w-2xl mt-6 mx-auto">
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;